/**
 * The href of the current page's navigation item — the most specific match
 * among the visible items and Settings — so exactly one item is highlighted.
 */

import { useLocation } from 'react-router-dom';

import { activeHrefFor } from './activeHref';
import { useVisibleNav } from './useVisibleNav';

export const SETTINGS_HREF = '/settings';

export function useActiveNavHref(): string | null {
  const { pathname } = useLocation();
  const sections = useVisibleNav();
  return activeHrefFor([SETTINGS_HREF, ...sections.flatMap((s) => s.items.map((i) => i.href))], pathname);
}
